export default __webpack_public_path__ + "static/media/twitter-original.8f1a461d.svg";